import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { Login } from '../modal/login';
import { pincode } from '../modal/pincode';
import { Observable } from 'rxjs';
import { User } from '../modal/user';
import { MulipleUserRegisterResDto } from '../modal/MulipleUserRegisterResDto';


@Injectable({
    providedIn: 'root'
})

export class MultipleUserRegistrationService {
    constructor(private httpclient: HttpClient, private global: Globals) { }


   
    multipleUserExcelFile(files)
      {
        let header: HttpHeaders = new HttpHeaders();
        header = header.append('Accept', 'application/json');
        header.append('Content-Type', 'multipart/form-data');
        // header.append('responseType','text');
        header = header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        let options={ headers: header };
        let uploadfiledata: FormData =new FormData();
        uploadfiledata.append('file',files);
          return this.httpclient.post<MulipleUserRegisterResDto[]>(this.global.G_apiUrl+'/userRegistration/multipleUserRegistration',uploadfiledata,options)
      }

}
